import { Component } from 'react';
import Cleave from 'cleave.js';
import { AsYouType } from 'libphonenumber-js/min';
const {
  NumeralFormatter,
  DateFormatter,
  TimeFormatter,
  PhoneFormatter,
  CreditCardDetector,
  Util,
  DefaultProperties
} = Cleave;
class CleaveComponent extends Component {
  constructor(props) {
    super(props);
    const {
      value,
      options,
      onKeyDown,
      onChange,
      onFocus,
      onBlur,
      onInit
    } = this.props;
    this.registeredEvents = {
      onInit: onInit || Util.noop,
      onChange: onChange || Util.noop,
      onFocus: onFocus || Util.noop,
      onBlur: onBlur || Util.noop,
      onKeyDown: onKeyDown || Util.noop
    };
    let opts = options || {};
    opts.initValue = value;
    this.properties = DefaultProperties.assign({}, opts);
    this.state = {
      value: this.properties.result,
      cursorPosition: 0
    };

    // Bind methods
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onInput = this.onInput.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate(prevProps) {
    const phoneRegionCode = (this.props.options || {}).phoneRegionCode;
    const newValue = this.props.value;
    const pps = this.properties;
    this.updateRegisteredEvents(this.props);
    if (prevProps.value !== newValue && newValue !== undefined && newValue !== null) {
      const valueString = newValue.toString();
      if (valueString !== this.properties.result) {
        this.properties.initValue = valueString;
        this.onInput(valueString, true);
      }
    }

    // update phone region code
    const prevPhoneRegionCode = (prevProps.options || {}).phoneRegionCode;
    if (prevPhoneRegionCode !== phoneRegionCode && phoneRegionCode && phoneRegionCode !== this.properties.phoneRegionCode) {
      this.properties.phoneRegionCode = phoneRegionCode;
      this.initPhoneFormatter();
      this.onInput(this.properties.result);
    }
    Util.setSelection(this.element, this.state.cursorPosition, pps.document);
  }
  updateRegisteredEvents(props) {
    const {
      onKeyDown,
      onChange,
      onFocus,
      onBlur,
      onInit
    } = this.registeredEvents;
    if (props.onInit && props.onInit !== onInit) this.registeredEvents.onInit = props.onInit;
    if (props.onChange && props.onChange !== onChange) this.registeredEvents.onChange = props.onChange;
    if (props.onFocus && props.onFocus !== onFocus) this.registeredEvents.onFocus = props.onFocus;
    if (props.onBlur && props.onBlur !== onBlur) this.registeredEvents.onBlur = props.onBlur;
    if (props.onKeyDown && props.onKeyDown !== onKeyDown) this.registeredEvents.onKeyDown = props.onKeyDown;
  }
  init() {
    const pps = this.properties;

    // so no need for this lib at all
    if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
      this.onInput(pps.initValue);
      this.registeredEvents.onInit(this);
      return;
    }
    pps.maxLength = Util.getMaxLength(pps.blocks);
    this.isAndroid = Util.isAndroid();
    this.initPhoneFormatter();
    this.initDateFormatter();
    this.initTimeFormatter();
    this.initNumeralFormatter();

    // avoid touch input field if value is null
    // otherwise Firefox will add red box-shadow for <input required />
    if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
      this.onInput(pps.initValue);
    }
    this.registeredEvents.onInit(this);
  }
  initNumeralFormatter() {
    const pps = this.properties;
    if (!pps.numeral) {
      return;
    }
    pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
  }
  initTimeFormatter() {
    const pps = this.properties;
    if (!pps.time) {
      return;
    }
    pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
    pps.blocks = pps.timeFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Util.getMaxLength(pps.blocks);
  }
  initDateFormatter() {
    const pps = this.properties;
    if (!pps.date) {
      return;
    }
    pps.dateFormatter = new DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
    pps.blocks = pps.dateFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Util.getMaxLength(pps.blocks);
  }
  initPhoneFormatter() {
    const pps = this.properties;
    if (!pps.phone) {
      return;
    }

    // adjusted to support using libformatter.js
    // https://github.com/nosir/cleave.js/blob/master/src/Cleave.react.js#L171-L180
    try {
      const formatter = new AsYouType(pps.phoneRegionCode);
      pps.phoneFormatter = new PhoneFormatter({
        inputDigit: char => formatter.input(char),
        clear: () => formatter.reset()
      }, pps.delimiter);
    } catch {
      throw new Error('Please include phone-type-formatter.{country}.js lib');
    }
  }
  setRawValue(value) {
    const pps = this.properties;
    value = value !== undefined && value !== null ? value.toString() : '';
    if (pps.numeral) {
      value = value.replace('.', pps.numeralDecimalMark);
    }
    pps.postDelimiterBackspace = false;
    this.onChange({
      target: {
        value: value
      },
      // Methods to better resemble a SyntheticEvent
      stopPropagation: Util.noop,
      preventDefault: Util.noop,
      persist: Util.noop
    });
  }
  getRawValue() {
    const pps = this.properties;
    let rawValue = pps.result;
    if (pps.rawValueTrimPrefix) {
      rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
    }
    if (pps.numeral) {
      rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
    } else {
      rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
    }
    return rawValue;
  }
  getISOFormatDate() {
    const pps = this.properties;
    return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
  }
  getISOFormatTime() {
    const pps = this.properties;
    return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
  }
  onInit(owner) {
    return owner;
  }
  onKeyDown(event) {
    const pps = this.properties;
    const charCode = event.which || event.keyCode;
    this.lastInputValue = pps.result;
    this.isBackward = charCode === 8;
    this.registeredEvents.onKeyDown(event);
  }
  onFocus(event) {
    const pps = this.properties;
    if (pps.prefix && pps.noImmediatePrefix && !event.target.value) {
      this.onInput(pps.prefix);
    }
    event.target.rawValue = this.getRawValue();
    event.target.value = pps.result;
    this.registeredEvents.onFocus(event);
    Util.fixPrefixCursor(this.element, pps.prefix, pps.delimiter, pps.delimiters);
  }
  onBlur(event) {
    const pps = this.properties;
    event.target.rawValue = this.getRawValue();
    event.target.value = pps.result;
    this.registeredEvents.onBlur(event);
  }
  onChange(event) {
    const pps = this.properties;
    this.isBackward = this.isBackward || event.inputType === 'deleteContentBackward';
    // hit backspace when last character is delimiter
    const postDelimiter = Util.getPostDelimiter(this.lastInputValue || '', pps.delimiter, pps.delimiters);
    if (this.isBackward && postDelimiter) {
      pps.postDelimiterBackspace = postDelimiter;
    } else {
      pps.postDelimiterBackspace = false;
    }
    this.onInput(event.target.value);
    event.target.rawValue = this.getRawValue();
    event.target.value = pps.result;
    this.registeredEvents.onChange(event);
  }
  onInput(value, fromProps) {
    const pps = this.properties;

    // case 1: delete one more character "4"
    // 1234*| -> hit backspace -> 123|
    // case 2: last character is not delimiter which is:
    // 12|34* -> hit backspace -> 1|34*
    const postDelimiterAfter = Util.getPostDelimiter(value || '', pps.delimiter, pps.delimiters);
    if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
      value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
    }

    // phone formatter
    if (pps.phone) {
      if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
        pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
      } else {
        pps.result = pps.phoneFormatter.format(value);
      }
      this.updateValueState();
      return;
    }

    // numeral formatter
    if (pps.numeral) {
      // Do not show prefix when noImmediatePrefix is specified
      // This mostly because we need to show user the native input placeholder
      if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
        pps.result = '';
      } else {
        pps.result = pps.numeralFormatter.format(value);
      }
      this.updateValueState();
      return;
    }

    // date
    if (pps.date) {
      value = pps.dateFormatter.getValidatedDate(value);
    }

    // time
    if (pps.time) {
      value = pps.timeFormatter.getValidatedTime(value);
    }

    // strip delimiters
    value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

    // strip prefix
    value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

    // strip non-numeric characters
    value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

    // convert case
    value = pps.uppercase ? value.toUpperCase() : value;
    value = pps.lowercase ? value.toLowerCase() : value;

    // prevent from showing prefix when no immediate option enabled with empty input value
    if (pps.prefix) {
      if (pps.tailPrefix) {
        value = value + pps.prefix;
      } else {
        value = pps.prefix + value;
      }

      // no blocks specified, no need to do formatting
      if (pps.blocksLength === 0) {
        pps.result = value;
        this.updateValueState();
        return;
      }
    }

    // update credit card props
    if (pps.creditCard) {
      this.updateCreditCardPropsByValue(value);
    }

    // strip over length characters
    value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value;

    // apply blocks
    pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
    this.updateValueState();
  }
  updateCreditCardPropsByValue(value) {
    const pps = this.properties;
    let creditCardInfo;

    // At least one of the first 4 characters has changed
    if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
      return;
    }
    creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
    pps.blocks = creditCardInfo.blocks;
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Util.getMaxLength(pps.blocks);

    // credit card type changed
    if (pps.creditCardType !== creditCardInfo.type) {
      pps.creditCardType = creditCardInfo.type;
      pps.onCreditCardTypeChanged.call(this, pps.creditCardType);
    }
  }
  updateValueState() {
    const pps = this.properties;
    if (!this.element) {
      this.setState({
        value: pps.result
      });
      return;
    }
    let endPos = this.element.selectionEnd;
    const oldValue = this.element.value;
    const newValue = pps.result;
    this.lastInputValue = newValue;
    endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
    if (this.isAndroid) {
      window.setTimeout(() => {
        this.setState({
          value: newValue,
          cursorPosition: endPos
        });
      }, 1);
      return;
    }
    this.setState({
      value: newValue,
      cursorPosition: endPos
    });
  }
  render() {
    /* eslint-disable unused-imports/no-unused-vars */
    const {
      value,
      options,
      onKeyDown,
      onFocus,
      onBlur,
      onChange,
      onInit,
      htmlRef,
      ...propsToTransfer
    } = this.props;
    /* eslint-enable unused-imports/no-unused-vars */

    return <input type="text" ref={ref => {
      this.element = ref;
      if (!htmlRef) {
        return;
      }
      htmlRef.current = ref;
    }} value={this.state.value} onKeyDown={this.onKeyDown} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} {...propsToTransfer} />;
  }
}
export default CleaveComponent;